<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.audit_list") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100
              .form-group.col
                .d-inline-block
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t('ui.refresh') }}
                    b-input-group-text(slot="append")
                      label.custom-switch
                        input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="$options.refreshOn" @change="toggleRefresh()")
                        span.custom-switch-indicator
                    b-input-group-text(slot="append")
                      b-input(v-model="refreshInterval" type="range" min="1" max="5")
                    b-input-group-text(slot="append")
                      span {{ refreshInterval }} s
              .form-group.col-12
                .row
                  .col-4
                    .form-group
                      b-input-group(size="sm")
                        b-form-select.col-4(v-model="searchType" size="sm" @input="resetInput()")
                          option(value="operator" v-if="!isOperator") {{ $t('ui.operator') }}
                          option(value="member" v-else-if="isOperator") {{ $t('ui.member') }}
                          option(value="ticket") {{ $t('ui.ticket') }}
                        template(v-if="['operator'].includes(searchType)")
                          DebounceInput(autofocus type="text" v-model="operatorID" :placeholder="$t('message.search_by_' + searchType)" @enter="getTicketList()" size="sm")
                        template(v-else-if="['member'].includes(searchType)")
                          DebounceInput(autofocus type="text" v-model="memberID" :placeholder="$t('ui.member')" @enter="getTicketList()" size="sm")
                        template(v-if="['ticket'].includes(searchType)")
                          DebounceInput(autofocus type="text" v-model="ticketId" :placeholder="$t('message.search_by_' + searchType)" @enter="getTicketList()" size="sm")
                  .col-6
                    template(v-if="['operator'].includes(searchType)")
                      template(v-if="operatorID != ''")
                        .form-group.col-6
                          b-input-group(size="sm")
                            b-input-group-text(slot="prepend")
                              i.fa.fa-search
                            DebounceInput(autofocus type="text" v-model="memberID" :placeholder="$t('ui.member')" size="sm")
              .form-group.col-12.mb-1
                SubmitButton(
                  icon="fa fa-search"
                  :loading="loading"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getTicketList()"
                  variant="primary"
                  size="sm"
                )

          .card-body
            .row
              .col-12
                ul#tickettab.nav.nav-tabs(role='tablist')
                  li.nav-item
                    a#withdrawal-tab.nav-link.active(data-toggle='tab' href='#withdrawal-content' role='tab' aria-controls='withdrawal' aria-selected='false')
                      span {{ $t("ui.withdrawal") }}
                      b-badge.ticket-total-badge(variant="danger" size="sm").ml-1 {{ totalRow }}

                #tickettabcontent.tab-content.tab-bordered
                  #deposit-content.tab-pane.active.show(role='tabpanel' aria-labelledby='deposit-tab')
                    .card.mb-0
                      .card-body
                        .row
                          .col-10.mb-1
                            b-pagination.float-left(
                              size="sm"
                              hide-ellipsis
                              :total-rows="totalRow"
                              :per-page="getPageSize"
                              v-model="currentPage"
                              @input="changedPage($event)").mb-1
                          .col-2.mb-1
                            b-input-group(:prepend="$t('ui.page_size')" size="sm")
                              b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
                          .col-12
                            .clusterize-scroll.table-responsive
                              table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                                thead.thead-light
                                  tr
                                    th.text-center(width="3%")
                                      span #
                                    th(width="5%")
                                      span(:title="$t('ui.id')") {{ $t('ui.id') }}
                                    th(width="8%")
                                      span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
                                    th(width="8%")
                                      span(:title="$t('ui.member')") {{ $t('ui.member') }}
                                    th.text-right(width="7%")
                                      span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                                    th(width="17%")
                                      span(:title="$t('ui.receiver_bank')") {{ $t("ui.receiver_bank") }}
                                    th.text-center(width="6%")
                                      span(:title="$t('ui.status')") {{ $t("ui.status") }}
                                    th.text-center(width="8%")
                                      span(:title="$t('ui.rollback_count')") {{ $t("ui.rollback_count") }}
                                    th.text-center(width="8%")
                                      span(:title="$t('ui.rejected_ticket_id')") {{ $t("ui.rejected_ticket_id") }}
                                    th.text-center(width="8%")
                                      span(:title="$t('ui.action')") {{ $t("ui.action") }}
                                    th.text-right(width="10%")
                                      span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                                tbody.clusterize-content
                                  tr(v-if="withdrawalList.length == 0")
                                    td(:colspan="11").text-center
                                      span {{ $t('message.no_data_available') }}
                                  tr(v-for="(item, index) in withdrawalList" :class="$helpers.rowClassTicket(item, 'withdrawal')")
                                    td.text-center
                                      span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                                    td
                                      span(:title="item.id") {{ item.id }}
                                    td
                                      span(:title="item.parent_id") {{ item.parent_id }}
                                    td
                                      span.font-weight-bold(:title="item.member_id")
                                        b-link.clickable(href="javascript:void(0);" @click="onInfo(item)") {{ item.member_id }}
                                    td.text-right
                                      span.font-weight-bold.d-block(:title="$n(item.amount, 'currency')" :class="$helpers.fontClassName(item.amount)") {{ $n(item.amount, 'currency') }}
                                    td
                                      span(:title="item.target_bank_id") {{ item.target_bank_id }}
                                      br
                                      span(:title="item.target_bank_acc_no") {{ item.target_bank_acc_no }}
                                      br
                                      span(:title="item.target_bank_acc_holder") {{ item.target_bank_acc_holder }}
                                      template(v-if="['ARS','AUD'].includes(getCurrencyCode)")
                                        br
                                        span(:title="item.target_bank_acc_remark") {{ item.target_bank_acc_remark }}
                                      template(v-if="['AUD'].includes(getCurrencyCode)")
                                        br
                                        span(:title="item.target_bank_acc_remark_2") {{ item.target_bank_acc_remark_2 }}
                                    td.text-center
                                      span(:class="$helpers.badgeClass(item.status)") {{ item.status.trim().toUpperCase() }}
                                    td.text-center
                                      span.font-weight-bold(:title="$n(item.rollback_count, 'integer')" v-if="item.rollback_count")
                                        b-link.clickable(href="javascript:void(0);" @click="onGetRollbackDetail(item)") {{ $n(item.rollback_count, 'integer') }}
                                      span(v-else) {{ item.rollback_count }}
                                    td.text-center
                                      span.font-weight-bold(:title="item.rejected_ticket_id" v-if="item.rejected_ticket_id")
                                        b-link.clickable(href="javascript:void(0);" @click="onGetRejectDetail(item)") {{ item.rejected_ticket_id }}
                                      span(v-else) {{ item.rejected_ticket_id }}
                                    td.actions.text-center
                                      span
                                        a.fa.fa-search.btn.btn-ssm.btn-primary(href="javascript:void(0)" @click="getTicketDetail(item)" :title="$t('ui.view')")
                                      template(v-if="isEditAccess")
                                        span.ml-1(v-if="item.status.trim().toUpperCase() == 'REVIEW'")
                                          a.fa.fa-check-double.btn.btn-ssm.btn-warning(href="javascript:void(0)" @click="auditTicket(item, $event)" :title="$t('ui.audit')")
                                        span.ml-1
                                          a.fa.fa-check.btn.btn-ssm.btn-success(href="javascript:void(0)" @click="approveTicket(item, $event)" :title="$t('ui.approve')")
                                        span.ml-1
                                          a.fas.fa-check-circle.btn.btn-ssm.btn-info(href="javascript:void(0)" @click="manualApproveTicket(item, $event)" :title="$t('ui.manual_approve')")
                                        span.ml-1
                                          a.fa.fa-ban.btn.btn-ssm.btn-danger(href="javascript:void(0)" @click="rejectTicket(item, $event)" :title="$t('ui.reject')")
                                    td.text-right
                                      span(v-if="item.created_date" :title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}

    ticketdetail(ref="ticketdetail" :ticketId="selectedTicketId" @failed="handleFailed")
    approveticket(ref="approveticket" :ticketId="selectedTicketId" :parentId="selectedParentId" :memberId="selectedMemberId" @clicked="afterEditTicket" @failed="handleFailed")
    auditticket(ref="auditticket" :ticketId="selectedTicketId" :memberId="selectedMemberId" @clicked="afterAuditTicket" @failed="handleFailed")
    rejectticket(ref="rejectticket" :ticketId="selectedTicketId" @clicked="afterEditTicket" @failed="handleFailed")
    getrecentdeposit(ref="getrecentdeposit" :item="editSelectedMember" @failed="handleFailed")
    getrollbackdetail(ref="getrollbackdetail" :item="selectedTicket" @failed="handleFailed")
    getrejectdetail(ref="getrejectdetail" :item="selectedTicket" @failed="handleFailed")
    manualapproveticket(ref="manualapproveticket" :ticketId="selectedTicketId" :parentId="selectedParentId" :memberId="selectedMemberId" @clicked="afterEditTicket" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import ticketdetail from "@/components/ticket/ticketDetail.vue";
import approveticket from "@/components/ticket/approveTicket.vue";
import rejectticket from "@/components/ticket/rejectTicket.vue";
import auditticket from "@/components/ticket/auditTicket.vue";
import getrecentdeposit from "@/components/ticket/getRecentDeposit.vue";
import getrollbackdetail from "@/components/ticket/getRollbackDetail.vue";
import getrejectdetail from "@/components/ticket/getRejectDetail.vue";
import manualapproveticket from "@/components/ticket/manualApproveTicket.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ticketdetail,
    approveticket,
    auditticket,
    rejectticket,
    getrecentdeposit,
    getrollbackdetail,
    getrejectdetail,
    manualapproveticket
  },
  data: () => ({
    loading: false,
    withdrawalList: [],
    currentDepPage: 1,
    currentPage: 1,
    totalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    requestType: null,
    ticketTimer: null,
    refreshInterval: 5,
    refreshChange: "",
    selectedTicketId: null,
    selectedTicket: null,
    selectedParentId: null,
    selectedMemberId: null,
    al: null,
    editSelectedMember: null,
    ticketId: "",
    searchType: "ticket",
    operatorID: "",
    memberID: "",
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_ticketlistreviewaudit");
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
  },
  created: function() {
    this.$options.refreshOn = false;
  },
  mounted: function() {
    this.getTicketList();
  },
  destroyed: function() {
    if (this.ticketTimer) {
      clearTimeout(this.ticketTimer);
    } 
    var json = {
      tab: null
    };
    this.$store.dispatch("user/setPendingTicketParam", json);
  },
  methods: {
    resetInput() {
      this.search = "";
      this.ticketId = "";
    },
    getTicketList() {
      this.getWithdrawalList(true);
    },
    getWithdrawalList: function(isSearch) {
      let url = config.ticketListReviewAuditUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        request_type: 'WITHDRAWAL',
        ticket_status: "AUDIT",
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      if(this.searchType == 'operator' || this.searchType == 'member') {
        json.operator_id = this.operatorID
        json.member_id = this.memberID
      } else {
        json.ticket_id = this.ticketId ? this.$helpers.getTicketId(this.ticketId) : null
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.withdrawalList = response.data.dt;
                this.totalRow = this.withdrawalList.length > 0 ? this.withdrawalList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getTicketDetail: function(e) {
      this.selectedTicketId = e.id;
      this.$refs.ticketdetail.$refs.ticketDetail.show();
    },
    onGetRollbackDetail(e) {
      this.selectedTicket = e;
      this.$refs.getrollbackdetail.$refs.getRollbackDetail.show();
    },
    onGetRejectDetail(e) {
      this.selectedTicket = e;
      this.$refs.getrejectdetail.$refs.getRejectDetail.show();
    },
    afterEditTicket: function(type, afterBalance) {
      this.getTicketList();

      if (type == 1) {
        this.$swal({
          title: this.$t("ui.combine.edit_ticket"),
          html:
            "<div>" +
            this.$t("ui.after_balance") +
            ": <strong>" +
            this.$n(afterBalance, 'currency') +
            "</strong></div>",
          type: "success",
          confirmButtonText: this.$t("ui.ok"),
          allowOutsideClick: false
        }).then(isConfirm => {
          if (isConfirm.value) {

          }
        });
      } else
        this.$helpers.showDialog(this.$t("ui.combine.edit_ticket"), this.$t("message.success"), "success");
    },
    afterAuditTicket: function() {
      this.getTicketList();
      this.$helpers.showDialog(this.$t("ui.combine.audit_ticket"), this.$t("message.success"), "success");
    },
    auditTicket: function(e) {
      this.selectedTicketId = e.id;
      this.selectedMemberId = e.member_id;
      this.$refs.auditticket.$refs.auditTicket.show();
    },
    approveTicket: function(e) {
      this.selectedTicketId = e.id;
      this.selectedParentId = e.parent_id;
      this.selectedMemberId = e.member_id;
      this.$refs.approveticket.$refs.approveTicket.show();
    },
    manualApproveTicket: function(e) {
      this.selectedTicketId = e.id;
      this.selectedParentId = e.parent_id;
      this.selectedMemberId = e.member_id;
      this.$refs.manualapproveticket.$refs.manualApproveTicket.show();
    },
    rejectTicket: function(e) {
      this.selectedTicketId = e.id;
      this.$refs.rejectticket.$refs.rejectTicket.show();
    },
    onInfo(e) {
      this.$store.dispatch("user/setSelectedOperatorID", e.parent_id);
      this.$router.push("/account/operator");
    },
    toggleRefresh: function() {
      this.startRefreshTimer();
    },
    startRefreshTimer: function() {
      if (this.ticketTimer) {
        clearTimeout(this.ticketTimer);
      }
      if (this.$options.refreshOn) {
        this.getTicketList();
        this.ticketTimer = setTimeout(() => {
          this.startRefreshTimer();
        }, this.refreshInterval * 1000);
      } else {
        this.refreshChange = "STOPPED";
      }
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getWithdrawalList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getWithdrawalList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>